import { render, staticRenderFns } from "./popupmessage.vue?vue&type=template&id=09d8ddb6&scoped=true&"
import script from "./popupmessage.vue?vue&type=script&lang=js&"
export * from "./popupmessage.vue?vue&type=script&lang=js&"
import style0 from "./popupmessage.vue?vue&type=style&index=0&id=09d8ddb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8ddb6",
  null
  
)

export default component.exports